(function () {
  function init() {
    var variantsScript = document.querySelector('[data-product-variants-json]');
    var optionsScript = document.querySelector('[data-product-option-values-json]');
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!variantsScript || !optionsScript || !idInput) return;

    var variants = JSON.parse(variantsScript.textContent);
    var optionsWithValues = JSON.parse(optionsScript.textContent);
    var sectionId = variantsScript.getAttribute('data-product-variants-json');
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return;

    var knownValues = [];
    optionsWithValues.forEach(function (opt) {
      opt.values.forEach(function (val) { knownValues.push(val.toLowerCase()); });
    });

    var slides = gallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
    var tagMap = new Map();
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      var alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
      var tags = knownValues.filter(function (kw) {
        return alt.indexOf('[' + kw + ']') !== -1;
      });
      tagMap.set(slide, tags);
    });

    // Getaggte Variantenbilder aktiv vorladen,
    // damit sie beim Variantenwechsel sofort verfügbar sind
    slides.forEach(function (slide) {
      var tags = tagMap.get(slide) || [];
      if (tags.length > 0) {
        var img = slide.querySelector('img');
        if (img) {
          img.removeAttribute('loading');
          var preload = new Image();
          if (img.srcset) {
            preload.srcset = img.srcset;
            preload.sizes = img.sizes;
          }
          preload.src = img.currentSrc || img.src;
        }
      }
    });

    function applyFilter(variantId) {
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (!variant) return;
      var selected = (variant.options || []).map(function (o) { return String(o).toLowerCase(); });
      slides.forEach(function (slide) {
        var tags = tagMap.get(slide) || [];
        var visible = tags.length === 0 || tags.every(function (t) { return selected.indexOf(t) !== -1; });
        slide.classList.toggle('variant-media-hidden', !visible);
      });
    }

    var lastValue = null;
    function check() {
      if (idInput.value !== lastValue) {
        lastValue = idInput.value;
        applyFilter(lastValue);
      }
    }
    check();
    setInterval(check, 300);

    // Filter synchron VOR Dawns setActiveMedia ausführen,
    // damit Scroll-/Offset-Berechnungen mit dem korrekten Layout passieren
    var MediaGalleryClass = customElements.get('media-gallery');
    if (MediaGalleryClass && !MediaGalleryClass.prototype.__variantFilterPatched) {
      var originalSetActiveMedia = MediaGalleryClass.prototype.setActiveMedia;
      MediaGalleryClass.prototype.setActiveMedia = function (mediaId, prepend) {
        check();
        return originalSetActiveMedia.call(this, mediaId, prepend);
      };
      MediaGalleryClass.prototype.__variantFilterPatched = true;
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();